import React, { useState } from 'react';
import { Button, HStack, Text, VStack } from '@chakra-ui/react';
import { KYB_KYC_SUCCESS_STATUS, RISK_LEVEL_COLOR_CODES } from 'constants/kyc';
import { PermissionsV2 } from 'constants/permissions_v2';
import PermissionWrapper from 'components/hoc/PermissionWrapper';
import UpdateKycStatusModal from 'components/KycRfi/UpdateKycStatusModal';

const KycRfiPreview = ({
  sumsub_applicant_id,
  entity_name,
  sumsub_kyc_status,
  kyc_status,
  status_remark,
  entityId,
  fetchKycDetails,
  sumsub_profile_url,
  super_merchant_name,
  resourceType,
  tags,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const isButtonVisible = kyc_status !== 'active' && kyc_status !== 'failed';

  return (
    <HStack
      border='1px solid'
      borderColor='gray.200'
      p={6}
      mt={6}
      borderRadius='md'
      background='white'
      spacing={6}
      alignItems='flex-start'
      flexWrap='wrap'
    >
      <VStack align='flex-start' spacing={3} flex={1}>
        <HStack gap={1}>
          <Text fontWeight='bold'>SuperMerchant:</Text>
          <Text>{super_merchant_name || 'N/A'}</Text>
        </HStack>
        <HStack gap={1}>
          <Text fontWeight='bold'>Entity Name:</Text>
          <Text>{entity_name || 'N/A'}</Text>
        </HStack>
        <HStack gap={1}>
          <Text fontWeight='bold'>Applicant Id:</Text>
          <Text>{sumsub_applicant_id || 'N/A'}</Text>
        </HStack>
      </VStack>
      <VStack align='flex-start' spacing={2} flex={1}>
        <HStack gap={1}>
          <Text fontWeight='bold'>Sumsub {resourceType} Status:</Text>
          <Text color={sumsub_kyc_status === 'PASS' ? 'green.500' : 'red.500'}>{sumsub_kyc_status || 'N/A'}</Text>
        </HStack>
        <HStack gap={1} w='full'>
          <Text fontWeight='bold'>Internal {resourceType} Status:</Text>
          <Text
            color={KYB_KYC_SUCCESS_STATUS.includes(kyc_status) ? 'green.500' : 'red.500'}
            textTransform={'UPPERCASE'}
          >
            {kyc_status || 'N/A'}
          </Text>
          {isButtonVisible && (
            <PermissionWrapper permission={PermissionsV2.MANAGE_KYB_COMPLIANCE_OPERATIONS}>
              <Button
                colorScheme='blue'
                size='sm'
                variant='outline'
                px={6}
                py={1}
                fontWeight='bold'
                onClick={() => setIsOpen(true)}
              >
                Update Status
              </Button>
            </PermissionWrapper>
          )}
        </HStack>
        {status_remark && (
          <HStack gap={1} align='flex-start'>
            <Text fontWeight='bold' whiteSpace='nowrap'>
              Status Remark:
            </Text>
            <Text>{status_remark}</Text>
          </HStack>
        )}
        {tags && (
          <HStack gap={4}>
            <HStack gap={1}>
              <Text fontWeight='bold'>Risk Tag:</Text>
              <Text color={RISK_LEVEL_COLOR_CODES[tags?.risk_tag]} textTransform={'capitalize'}>
                {tags?.risk_tag}
              </Text>
            </HStack>
            <HStack gap={1}>
              <Text fontWeight='bold'>EDD Tag:</Text>
              <Text>{tags?.edd_tag}</Text>
            </HStack>
            <HStack gap={1}>
              <Text fontWeight='bold'>PEP Tag:</Text>
              <Text>{tags?.pep_tag}</Text>
            </HStack>
          </HStack>
        )}
      </VStack>
      <UpdateKycStatusModal
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        kyc_status={kyc_status}
        sumsub_kyc_status={sumsub_kyc_status}
        entityId={entityId}
        fetchKycDetails={fetchKycDetails}
        sumsub_profile_url={sumsub_profile_url}
        resourceType={resourceType}
      />
    </HStack>
  );
};

export default KycRfiPreview;
